import React, { useEffect } from 'react';
export function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="bg-white min-h-screen pt-32 pb-24" data-id="element-678">
      <div className="max-w-4xl mx-auto px-6" data-id="element-679">
        <h1 className="text-4xl md:text-5xl font-serif mb-8 text-brand-black" data-id="element-680">
          Terms of Service
        </h1>
        <p className="text-gray-500 mb-12 uppercase tracking-widest text-sm" data-id="element-681">
          Last Updated: January 2026
        </p>

        <div className="space-y-8 text-gray-700 leading-relaxed" data-id="element-682">
          <section data-id="element-683">
            <h2 className="text-2xl font-serif text-brand-black mb-4" data-id="element-684">
              1. Agreement to Terms
            </h2>
            <p data-id="element-685">
              By accessing our website and utilizing the catering and meal prep
              services of Versatile LLC Cater 2 U, you agree to be bound by
              these Terms of Service. If you do not agree to these terms, please
              do not use our services.
            </p>
          </section>

          <section data-id="element-686">
            <h2 className="text-2xl font-serif text-brand-black mb-4" data-id="element-687">
              2. Booking and Payments
            </h2>
            <p data-id="element-688">
              A non-refundable deposit is required to secure your event date.
              The remaining balance must be paid in full prior to the event date
              as specified in your catering contract. For meal prep
              subscriptions, payments are processed on a recurring basis as
              agreed upon during sign-up.
            </p>
          </section>

          <section data-id="element-689">
            <h2 className="text-2xl font-serif text-brand-black mb-4" data-id="element-690">
              3. Cancellations and Modifications
            </h2>
            <p data-id="element-691">
              Cancellations must be made in writing. Deposits are
              non-refundable. Cancellations made within a certain timeframe of
              the event (as detailed in your specific contract) may require full
              payment. Final guest counts and menu modifications must be
              submitted by the deadline specified in your agreement.
            </p>
          </section>

          <section data-id="element-692">
            <h2 className="text-2xl font-serif text-brand-black mb-4" data-id="element-693">
              4. Dietary Restrictions and Allergies
            </h2>
            <p data-id="element-694">
              While we strive to accommodate dietary restrictions and allergies
              (e.g., vegan, gluten-free, halal), our kitchen processes various
              ingredients. We cannot guarantee a 100% allergen-free environment
              and are not liable for adverse reactions.
            </p>
          </section>

          <section data-id="element-695">
            <h2 className="text-2xl font-serif text-brand-black mb-4" data-id="element-696">
              5. Liability
            </h2>
            <p data-id="element-697">
              Versatile LLC is not responsible for any damage to the event venue
              or personal property caused by guests. Our liability is limited to
              the total amount paid for the catering services provided.
            </p>
          </section>
        </div>
      </div>
    </div>;
}